import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BtnForms from "../components/UiComponents/forms/BtnForms";
import NavContext from "../context/NavContext";
import styles from "./Erreur404.module.scss";
const Erreur404 = () => {
  const { userAuth } = useContext(NavContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const redirectionUser = (params) => {
    if (userAuth) {
      navigate("/private/dashboard");
    } else {
      navigate("/");
    }
  };

  return (
    <div className={styles.fixed}>
      <div className={styles.container}></div>
      <h1>{t("error404.title")}</h1>
      <h1>{t("error404.subtitle")}</h1>
      <img src="https://i.gifer.com/X5NY.gif" alt="" />
      {userAuth ? (
        <BtnForms
          onClick={redirectionUser}
          text={t("error404.go_dashboard")}
          style={{ width: "200px" }}
        />
      ) : (
        <BtnForms
          onClick={redirectionUser}
          text={t("error404.go_login")}
          style={{ width: "200px" }}
        />
      )}
    </div>
  );
};

export default Erreur404;
